/* eslint-disable func-names */
/* eslint-disable no-underscore-dangle */
// offset 取得
const getOffset = $t => {
  const area = $t.getBoundingClientRect();
  return {
    top: area.top + window.pageYOffset - document.documentElement.clientTop,
    left: area.left + window.pageXOffset - document.documentElement.clientLeft,
  };
};

// scorll frame in trigger
const Sticky = function($parent, $childSelector) {
  const _this = this;

  _this.$parent = $parent;
  if (!_this.$parent) return;

  _this.$parent.setAttribute('data-fixed', 'true');
  _this.busy = 'true';

  _this.child = _this.$parent.querySelector($childSelector);

  _this.processing = false;

  _this.init();
};

// init
Sticky.prototype.init = function() {
  const _this = this;
  window.addEventListener('scroll', _this.judge.bind(_this));
  window.addEventListener('resize', _this.judge.bind(_this));
  _this.judge.call(_this);
};

// judge
Sticky.prototype.judge = function() {
  const _this = this;

  const childH = _this.child.clientHeight;

  const scrollY =
    window.scrollY === undefined ? document.documentElement.scrollTop : window.scrollY;
  const { top } = getOffset(_this.$parent);
  let innerY = 'true'; // 画面外に見切れるたびリセット

  const bufferY = 82 + 40;

  // 上に見切れたかどうか
  const under = function() {
    const bottom = top + _this.$parent.clientHeight - childH - bufferY;
    return bottom > scrollY;
  };

  // 下から出現したかどうか
  const upper = function() {
    const area = scrollY + 82 + 40;
    return area > top;
  };

  if (window.innerWidth >= 768) {
    if (scrollY < top) _this.child.style.removeProperty('top');
    if (under(_this.$parent) && upper(_this.$parent)) {
      innerY = 'false';
      _this.child.style.setProperty('top', `${scrollY - top + bufferY}px`);
    }
  }
  if (_this.busy !== innerY) {
    _this.$parent.setAttribute('data-fixed', innerY);
    _this.busy = innerY;
    if (window.innerWidth < 768) _this.child.style.removeProperty('top');
  }
};

// EXPORT
export default ($parent, $childSelector) => new Sticky($parent, $childSelector);
